import i18next, { i18n } from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import Backend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend'; // primary use cache
import Cookies from 'js-cookie';

i18next
  .use(Backend)
  // .use(LanguageDetector) // 自动检测浏览器语言
  .use(initReactI18next) // 绑定 React
  .init({
    lng: Cookies.get('i18next') || "zh-HK",
    supportedLngs: ['en', 'zh-HK', 'zh-CN'], // 支持的语言
    fallbackLng: "zh-HK", // 默认语言
    // debug: process.env.NODE_ENV === "development", // 开发模式开启调试
    interpolation: {
      escapeValue: false, // React 默认转义，无需额外处理
    },
    load: 'currentOnly',
    retryTimeout: 500,
    maxRetries: 2,
    backend: {
      backends: import.meta.env.DEV ? [
        HttpBackend               // fallback backend
      ] : [
        LocalStorageBackend,  // primary backend
        HttpBackend               // fallback backend
      ],
      backendOptions: [{
        // prefix for stored languages
        prefix: 'i18next_res_',

        // expiration
        expirationTime: 7*24*60*60*1000,

        // language versions
        versions: { en: 'v2.39', "zh-HK": 'v2.43', "zh-CN": 'v1.11' },
      }, {
        /* options for HTTP backend */
        loadPath: "/locales/{{lng}}/{{ns}}.json", // 远程翻译文件路径
      }]
    },
    react: {
        useSuspense: false, // 禁用 suspense，避免加载翻译文件时出现闪烁
    },
    detection: {
      // 配置语言检测器
      order: ['cookie', 'localStorage', 'navigator'],
      caches: ['cookie'] // 将语言设置缓存到 cookie
    }
  }).then(() => {
    console.log("i18n initialized successfully");
  }).catch((error) => {
    console.error("i18n initialization failed", error);
  });

function getLanguage(i ?: i18n): string {
  return i?.language || Cookies.get('i18next') || 'zh-HK';
}

export function isEN(i ?: i18n): boolean {
  return getLanguage(i) === 'en';
}

export function isHK(i ?: i18n): boolean {
  return getLanguage(i) === 'zh-HK';
}

export function isCN(i ?: i18n): boolean {
  return getLanguage(i) === 'zh-CN';
}

export default i18next;